import script from "./CommunicationUpdate.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunicationUpdate.vue?vue&type=script&setup=true&lang=js"

import "./CommunicationUpdate.vue?vue&type=style&index=0&id=8ad9765c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ad9765c"]])

export default __exports__